import React from 'react';
import cx from 'classnames';
import './MainPageTemplate.scss';

const MainPageTemplate = (props) => {
  const { isCollapsed, children } = props;
  return (
    <div id="main-page-template" className={cx({ isCollapsed })}>
      <main>{children}</main>
    </div>
  );
};

export default MainPageTemplate;
